import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '@service/auth.service';
import { environment } from '../environment/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const setHeaders: Record<string, string> = {};

    if (this.authService.authToken) {
      const accessToken = this.authService.authToken.access;

      if (accessToken) {
        setHeaders['Authorization'] = `Bearer ${accessToken}`;
      }
    }

    const apiReq = req.clone({
      url: `${environment.apiUrl}${req.url}`,
      setHeaders,
    });

    return next.handle(apiReq);
  }
}
